import { render } from "./ResultTableItem.vue?vue&type=template&id=54d9055a&scoped=true"
import script from "./ResultTableItem.vue?vue&type=script&lang=js"
export * from "./ResultTableItem.vue?vue&type=script&lang=js"

import "./ResultTableItem.vue?vue&type=style&index=0&id=54d9055a&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d9055a"]])

export default __exports__